export const maskEmail = (email: string) => {
    const [left, right] = email.split('@')
    if (left.length < 12) return email
    return `${left.substring(0, 5)}•••${left.substring(
        left.length - 2
    )}@${right}`
}
